export default {"src":"/_next/static/media/character-c.colour.07c13296.svg","height":364,"width":364,"blurWidth":0,"blurHeight":0};